import { useEffect, useState } from 'react';
import api from '../services/api';

const servicesCache = new Map();
let stylistsCache = null;

/** Price list for one branch + the stylist list, cached for the session. */
export default function useCatalog(franchiseId) {
  const fid = String(franchiseId || '');
  const [services, setServices] = useState(() => servicesCache.get(fid) || []);
  const [stylists, setStylists] = useState(() => stylistsCache || []);
  const [loading, setLoading] = useState(Boolean(fid) && !servicesCache.has(fid));
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    if (!fid) {
      setServices([]);
      setLoading(false);
      return undefined;
    }
    if (servicesCache.has(fid)) {
      setServices(servicesCache.get(fid));
      setLoading(false);
    } else {
      setLoading(true);
      api
        .services(fid)
        .then((items) => {
          servicesCache.set(fid, items);
          if (alive) {
            setServices(items);
            setError('');
          }
        })
        .catch((e) => alive && setError(e.message || 'Could not load services'))
        .finally(() => alive && setLoading(false));
    }
    return () => {
      alive = false;
    };
  }, [fid]);

  useEffect(() => {
    if (stylistsCache) return undefined;
    let alive = true;
    api
      .stylists()
      .then((items) => {
        stylistsCache = items;
        if (alive) setStylists(items);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return { services, stylists, loading, error };
}
